import Parse from "parse";

export interface CategoryAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
}

export class Category extends Parse.Object<CategoryAttributes> {
  static className: string = "Antiscam_Category";

  constructor(data?: Partial<CategoryAttributes>) {
    super("Antiscam_Category", data as CategoryAttributes);
  }

  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Category", Category);
